export function setIdLeadInUrl(idlead, targets = []) {
  targets.forEach(baseUrl => {
    // Buscar iframes
    document.querySelectorAll("iframe").forEach(el => {
      if (el.src.startsWith(baseUrl)) {
        let url = new URL(el.src);
        url.searchParams.set("idlead", idlead);
        el.src = url.toString();
      }
    });

    // Buscar enlaces
    document.querySelectorAll("a").forEach(el => {
      if (el.href.startsWith(baseUrl)) {
        let url = new URL(el.href);
        url.searchParams.set("idlead", idlead);
        el.href = url.toString();
      }
    });
  });
}